import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section className="contact-section">
      {/* 🔥 PAGE MAIN HEADING */}
      <h1 className="page-main-heading">“संपर्क”</h1>

      <div className="contact-container">
        {/* LEFT SIDE INFO */}
        <div className="contact-left">
          <h2 className="contact-title">संपर्क करा</h2>

          <div className="contact-box">
            <h3>ग्रंथालयाचे नाव</h3>
            <p>
              कै. रघुनाथ रामचंद्र बुरांडे ग्रंथालय <br />
              कोडोली, ता. पन्हाळा, जि. कोल्हापूर
            </p>
          </div>

          <div className="contact-box">
            <h3>पत्ता</h3>
            <p>
              कोडोली हौसिंग सोसायटी, बिरोबा मंदिर समोर <br />
              कोडोली-पोखले रोड, कोडोली <br />
              तालुका पन्हाळा, जिल्हा कोल्हापूर
            </p>
          </div>

          <div className="contact-box">
            <h3>मोबाईल</h3>
            <p>८७६६५६९१०१ / ७५८८५७७२०९</p>
          </div>

          <div className="contact-box">
            <h3>ईमेल</h3>
            <p>rrburandegranthalay@gmail.com</p>
          </div>
        </div>

        {/* RIGHT SIDE MAP WITH FLOATING CARD */}
        <div className="contact-right">
          <iframe
            title="Library Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.0829679663157!2d74.18828767394942!3d16.871789817456094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc1a7819ba05f93%3A0x86015abced18340b!2sKai%20Raghunath%20Ramchandra%20Burande%20Granthalaya%20Kodoli!5e0!3m2!1sen!2sin!4v1780039408767!5m2!1sen!2sin"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>

         
        </div>
      </div>
    </section>
  );
};

export default Contact;